import { render, staticRenderFns } from "./chain.vue?vue&type=template&id=179f2eb1&scoped=true"
import script from "./chain.vue?vue&type=script&lang=js"
export * from "./chain.vue?vue&type=script&lang=js"
import style0 from "./chain.vue?vue&type=style&index=0&id=179f2eb1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179f2eb1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('179f2eb1')) {
      api.createRecord('179f2eb1', component.options)
    } else {
      api.reload('179f2eb1', component.options)
    }
    module.hot.accept("./chain.vue?vue&type=template&id=179f2eb1&scoped=true", function () {
      api.rerender('179f2eb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/softBusinessLogistics/chain.vue"
export default component.exports